let ComputerDetailsComponent = (props) =>{
    return(
        <tr>
            <td className="samestyling_td">{props.CoursrName}</td>
            <td className="samestyling_td">{props.FromWhere}</td>
            <td className="samestyling_td">{props.PassingYearC}</td>
            <td className="samestyling_td">{props.PercentageC}</td>
        </tr>
    );
}

export default ComputerDetailsComponent;